import { Button, Form, Checkbox, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Login = () => {
  const [showError, setShowError] = useState("");
  const navigate = useNavigate();

  // validation handler
  const validationHandler = (values) => {
    if (
      values?.email === process.env.REACT_APP_FRONTED_ADMIN_EMAIL &&
      values?.password === process.env.REACT_APP_FRONTED_ADMIN_PASSWORD
    ) {
      setShowError("email and password not matched");
    } else if (values?.email === process.env.REACT_APP_FRONTED_ADMIN_EMAIL) {
      setShowError("email not matched");
    } else if (
      values?.password === process.env.REACT_APP_FRONTED_ADMIN_PASSWORD
    ) {
      setShowError("password not matched");
    }
  };

  // onFinish
  const onFinish = (values) => {
    if (
      values?.email === process.env.REACT_APP_FRONTED_ADMIN_EMAIL &&
      values?.password === process.env.REACT_APP_FRONTED_ADMIN_PASSWORD
    ) {
      localStorage.setItem("login", "true");
      setShowError("");
      navigate("/");
    } else {
      validationHandler(values);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <Form
          name="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <p className="welcome_head">GNG DUOMO ADMINPANEL</p>

          <Form.Item
            name="email"
            rules={[{ required: true, message: "Please enter your email!" }]}
          >
            <Input placeholder="Email" style={{ fontSize: "16px" }} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              placeholder="Password"
              style={{ fontSize: "16px" }}
            />
          </Form.Item>
          <div>
            <p style={{ fontSize: "14px", color: "#ff4d4f", marginTop: "0px" }}>
              {showError}
            </p>
          </div>
          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              LOGIN
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
